export const DETACHED_MEDIA_QUERY = "(max-width: 1023px)";
